import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { useCallback } from 'react';
import { chain } from 'react-aria';
import Dialog from './primitives/dialog.esm.js';
import AlertDialogLayout from '../layout/alert-dialog/alert-dialog.esm.js';

var _excluded = ["title", "slots", "showCloseIcon", "hideFooter", "cancelLabel", "actionLabel", "onAction", "onCancel", "onClose", "children", "classNames", "scrollBarId"];
function AlertDialog(_ref) {
  var title = _ref.title,
    _ref$slots = _ref.slots,
    slots = _ref$slots === void 0 ? {} : _ref$slots,
    showCloseIcon = _ref.showCloseIcon,
    hideFooter = _ref.hideFooter,
    cancelLabel = _ref.cancelLabel,
    actionLabel = _ref.actionLabel,
    onAction = _ref.onAction,
    onCancel = _ref.onCancel,
    onClose = _ref.onClose,
    children = _ref.children,
    classNames = _ref.classNames,
    scrollBarId = _ref.scrollBarId,
    props = _objectWithoutProperties(_ref, _excluded);
  var handleClose = useCallback(function () {
    return onClose && onClose();
  }, [onClose]);
  return /*#__PURE__*/React.createElement(Dialog, _extends({
    role: "alertdialog"
  }, props), function (_ref2) {
    var close = _ref2.close;
    return /*#__PURE__*/React.createElement(AlertDialogLayout, {
      title: title,
      slots: slots,
      showCloseIcon: showCloseIcon,
      hideFooter: hideFooter,
      cancelLabel: cancelLabel,
      actionLabel: actionLabel,
      onAction: onAction,
      onCancel: onCancel,
      onClose: chain(close, handleClose),
      classNames: classNames,
      scrollBarId: scrollBarId
    }, children);
  });
}

export { AlertDialog as default };
//# sourceMappingURL=alert-dialog.esm.js.map
